import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const auditTrail = createAsyncThunk(
  "auditTrail/fetch",
  async (data, { rejectWithValue, serializeError }) => {
    try {
      const response = await axios.post(
        `${base_url}/digilocker/auditTrail/${data}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const auditTrailSlice = createSlice({
  name: "auditTrail",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(auditTrail.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(auditTrail.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(auditTrail.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default auditTrailSlice.reducer;
